import React, { useState } from 'react';
import cn from "classnames";
import style from "./index.module.scss";
import UncheckCircleIcon from '../../shared/icons/UncheckCircleIcon';
import ArrowUpIcon from '../../shared/icons/ArrowUpIcon';
import CustomButton from '../../custom/custom-button/CustomButton';
import ArrowDownIconNew from '../../shared/icons/ArrowDownIconNew';
import { useNavigate } from 'react-router-dom';
import CheckVerifiedIcon from '../../shared/icons/CheckVerifiedIcon';
import { User } from '../../../services';
import { useDispatch } from 'react-redux';
import { setUserData } from '../../../store/actions/userAction';
import {t} from "i18next";

const VideoInstruction = ({
    user,
    setIsOpenEmail,
    setIsOpenDocuments,
    isOpenInstruction,
    setIsOpenInstruction
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const toggleLowerCard = () => {
        // setIsOpenInstruction(!isOpenInstruction);
        // setIsOpenEmail(false);
        // setIsOpenDocuments(false);
    };

    const handleOpenVideo = () => {
        updateUserStep();
        window.open("https://www.youtube.com/watch?v=MH0xYd055jI", "_blank");
    };

    const updateUserStep = () => {
        User.updateStep(2)
            .then(() => {
                updateUserData();
                console.log("Step успешно обновлен");
            }).catch(error => {
                console.error("Error updating step:", error);
            });
    };

    const updateUserData = () => {
        User.get()
            .then(response => {
                console.log("[App]", response)
                dispatch(setUserData(response.data));
            })
            .catch(error => {
                console.log(error)
            });
    }

    const handleCreateDrivers = () => {
        updateUserStep();
        navigate('/drivers/create');
    }

    return (
        <div className={cn(style.card, {[style.isBg]: isOpenInstruction})}>
            <div className={style.card_upper}>
                <div className={style.card_head} onClick={toggleLowerCard}>
                    {user.step === 2 ? (
                        <CheckVerifiedIcon width={24} height={24}/>
                    ) : (
                        <UncheckCircleIcon/>
                    )}
                    <div className={style.card_title}>
                        {t('onboarding.instruction.addDriver')}
                    </div>
                </div>
                <div className={style.card_text}>
                    {t('onboarding.instruction.driverInstruction')}
                </div>
            </div>
            <div className={cn(style.card_lower, {[style.isDisplay]: isOpenInstruction})}>
                <CustomButton text={t('onboarding.instruction.buttonDriver')} isWhite onClick={handleCreateDrivers}/>
            </div>

            <div className={cn(style.card_lower, {[style.isDisplay]: !isOpenInstruction})}>
                {isOpenInstruction ? (
                    <>
                        <div className={style.card_video} onClick={handleOpenVideo}></div>
                        <div className={style.card_info}>
                            <div className={style.card_video_title}>
                                {t('onboarding.instruction.howAddDriver')}
                            </div>
                            <div className={style.card_video_time}>
                                01:24
                            </div>
                        </div>
                    </>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
}

export default VideoInstruction;
